/**
 * Utility functions to generate data attributes for components
 */

export const getComponentType = (componentName: string): string => {
  if (componentName.toLowerCase().includes("hero")) return "hero";
  if (componentName.toLowerCase().includes("keyservices")) return "services";
  if (componentName.toLowerCase().includes("about")) return "about";
  if (componentName.toLowerCase().includes("cta")) return "cta";
  if (componentName.toLowerCase().includes("faq")) return "faq";
  if (componentName.toLowerCase().includes("approach")) return "approach";
  if (componentName.toLowerCase().includes("testimonial")) return "testimonials";
  if (componentName.toLowerCase().includes("insurance")) return "insurance";
  if (componentName.toLowerCase().includes("pricing")) return "pricing";
  if (componentName.toLowerCase().includes("resources")) return "resources";
  if (componentName.toLowerCase().includes("locations")) return "locations";
  if (componentName.toLowerCase().includes("provider")) return "providers";
  return "component";
};

export const getComponentStyle = (componentName: string): string => {
  if (componentName.toLowerCase().includes("bigbold")) return "bigBold";
  if (componentName.toLowerCase().includes("modernclean")) return "modernClean";
  if (componentName.toLowerCase().includes("traditional")) return "traditional";
  return "default";
};

/**
 * Generates data attributes for a component based on its name
 */
export const generateComponentDataAttributes = (componentName: string) => ({
  "data-component-name": componentName,
  "data-component-type": getComponentType(componentName),
  "data-component-style": getComponentStyle(componentName),
});

/**
 * Creates props with data attributes for a component
 */
export const createComponentProps = (component: { name: string }): Record<string, any> => ({
  ...generateComponentDataAttributes(component.name),
});
